import PermissionService from "@/services/PermissionService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const permission = {
    namespace:true,
    state: {infoRoles:{},fail:bool,roleHasPermission:{},allPermission:{} },
    actions: {
        async getRolHasPermission({commit},id){
            return await PermissionService.getRolHasPermission(id).then(
                response=>{    
                    commit('setRoleHasPermission',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async getAllPermission({commit}){          
            return await PermissionService.getAllPermission().then (
                response =>{                    
                    commit('setAllPermission',response)                     
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        async getInfoRol({commit},id){          
            return await PermissionService.getInfoRol(id).then (
                response =>{                    
                    commit('setInfoRoles',response)                     
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setInfoRoles(state,data){
        state.infoRoles = data
    },
    setAllPermission(state,data){
        state.allPermission = data
    },
    setRoleHasPermission(state,data){        
        state.roleHasPermission = data
    },
    setFailure(state){
        state.fail = false
    },
  }
};